import Vue from 'vue';
import {
  findIndex, clone, cloneDeep, orderBy,
} from 'lodash';
import api from 'src/api';

// в константы выносим только названия мутаций,
// которые переиспользуем/планируем переиспользовать
export const FETCHING = 'FETCHING';
export const STOP_FETCHING = 'STOP_FETCHING';

const data = {
  ucceMrds: [],
  fetching: false,
};

const actions = {
  fetchUcceMrds({ commit }) {
    commit(FETCHING);
    return api.getUcceMrds().then((ucceMrds) => {
      commit('SYNC', ucceMrds);
    }).catch((err) => {
      commit(STOP_FETCHING);
      throw err;
    });
  },
  createUcceMrd({ commit }, { model }) {
    commit(FETCHING);
    return api.createUcceMrd(model).then((ucceMrd) => {
      commit('ADD_UCCE_MRD', ucceMrd);
    }).catch((err) => {
      commit(STOP_FETCHING);
      throw err;
    });
  },
  updateUcceMrd({ commit }, { id, model }) {
    commit(FETCHING, id);
    return api.updateUcceMrd(id, model).then((ucceMrd) => {
      commit('UPDATE_UCCE_MRD', ucceMrd);
    }).catch((err) => {
      commit(STOP_FETCHING);
      throw err;
    });
  },
  removeUcceMrd({ commit }, id) {
    commit(FETCHING, id);
    return api.deleteUcceMrd(id)
      .then(() => commit('REMOVE_UCCE_MRD', id))
      .catch((err) => {
        commit(STOP_FETCHING);
        throw err;
      });
  },
};

const mutations = {
  SYNC(state, ucceMrds) {
    state.ucceMrds = cloneDeep(orderBy(ucceMrds, 'mrdName'));
    mutations.STOP_FETCHING(state);
  },
  FETCHING(state) {
    state.fetching = true;
  },
  STOP_FETCHING(state) {
    state.fetching = false;
  },
  ADD_UCCE_MRD(state, ucceMrd) {
    state.ucceMrds.push(clone(ucceMrd));
  },
  UPDATE_UCCE_MRD(state, ucceMrd) {
    const { id } = ucceMrd;
    const { ucceMrds } = state;
    const index = findIndex(ucceMrds, { id });
    Vue.set(ucceMrds, index, { ...ucceMrds[index], ...ucceMrd });
  },
  REMOVE_UCCE_MRD(state, id) {
    const { ucceMrds } = state;
    Vue.delete(ucceMrds, findIndex(ucceMrds, { id }));
  },
};

const getters = {
  getUcceMrdById(state) {
    const { ucceMrds } = state;
    return (id) => (ucceMrds[findIndex(ucceMrds, { id })]);
  },
};

const store = {
  namespaced: true,
  state: data,
  actions,
  mutations,
  getters,
};

export default store;
